import { Chart, registerables } from 'chart.js';
import { BarWithErrorBarsController, BarWithErrorBar } from 'chartjs-chart-error-bars';
import { LinearScale, CategoryScale } from 'chart.js';
// register controller in chart.js and ensure the defaults are set
Chart.register(BarWithErrorBarsController, BarWithErrorBar, LinearScale, CategoryScale,
    ...registerables);


/**
 * Copyright 2014 Carl Craig
 * tc-angular-chartjs is dual licensed with the Apache-2.0 or MIT license.
 */

(function() {
  'use strict';


  function EpfChartjs(EpfChartjsFactory) {
    return new EpfChartjsFactory();
  }

  EpfChartjs.$inject = ['EpfChartjsFactory'];

  function EpfChartjsLine(EpfChartjsFactory) {
    return new EpfChartjsFactory('line');
  }

  EpfChartjsLine.$inject = ['EpfChartjsFactory'];

  function EpfChartjsBar(EpfChartjsFactory) {
    return new EpfChartjsFactory('bar');
  }

  EpfChartjsBar.$inject = ['EpfChartjsFactory'];

  function EpfChartjsHorizontalBar(EpfChartjsFactory) {
    return new EpfChartjsFactory('horizontalbar');
  }

  EpfChartjsHorizontalBar.$inject = ['EpfChartjsFactory'];

  function EpfChartjsRadar(EpfChartjsFactory) {
    return new EpfChartjsFactory('radar');
  }

  EpfChartjsRadar.$inject = ['EpfChartjsFactory'];

  function EpfChartjsPolararea(EpfChartjsFactory) {
    return new EpfChartjsFactory('polararea');
  }

  EpfChartjsPolararea.$inject = ['EpfChartjsFactory'];

  function EpfChartjsPie(EpfChartjsFactory) {
    return new EpfChartjsFactory('pie');
  }

  EpfChartjsPie.$inject = ['EpfChartjsFactory'];

  function EpfChartjsDoughnut(EpfChartjsFactory) {
    return new EpfChartjsFactory('doughnut');
  }

  EpfChartjsDoughnut.$inject = ['EpfChartjsFactory'];

  function EpfChartjsFactory() {
    return function(chartType) {
      function link($scope, $elem) {
        var ctx = $elem[0].getContext('2d');
        var chartObj;

        function getChartConfig(type, data, options) {
          var configType = type;
          var configOptions = angular.extend({}, options);

          // Chart.js v3+ removed the dedicated 'horizontalBar' chart type.
          if (type === 'horizontalbar') {
            configType = 'bar';
            configOptions = angular.extend({}, configOptions, {
              indexAxis: 'y'
            });
          }

          return {
            type: configType,
            data: data,
            options: configOptions
          };
        }

        $scope.$on('$destroy', function() {
          if (chartObj) {
            chartObj.destroy();
          }
        });

        $scope.$watch(
          'data',
          function(value) {
            if (value) {
              if (chartObj) {
                chartObj.destroy();
              }
              if (chartType) {
                chartObj = new Chart(ctx, getChartConfig(chartType, $scope.data, $scope.options));
              } else if ($scope.type) {
                chartObj = new Chart(ctx, getChartConfig($scope.type, $scope.data, $scope.options));
              } else {
                throw 'Error creating chart: Chart type required.';
              }
            }
          },
          true
        );
      }

      var directive = {
        restrict: 'A',
        scope: {
          data: '=chartData',
          options: '=chartOptions',
          type: '@chartType',
          legend: '=chartLegend',
          chart: '=chart'
        },
        link: link
      };

      return directive;
    };
  }

  function EpfChartjsLegend() {
    function link($scope, $elem) {
      $scope.$watch(
        'legend',
        function(value) {
          if (value) {
            $elem.html(value);
          }
        },
        true
      );
    }

    var directive = {
      restrict: 'A',
      scope: {
        legend: '=chartLegend'
      },
      link: link
    };

    return directive;
  }

  EpfChartjsLegend.$inject = [];

  angular
    .module('epf.core')
    .directive('epfChartjs', EpfChartjs)
    .directive('epfChartjsLine', EpfChartjsLine)
    .directive('epfChartjsBar', EpfChartjsBar)
    .directive('epfChartjsHorizontalBar', EpfChartjsHorizontalBar)
    .directive('epfChartjsRadar', EpfChartjsRadar)
    .directive('epfChartjsPolararea', EpfChartjsPolararea)
    .directive('epfChartjsPie', EpfChartjsPie)
    .directive('epfChartjsDoughnut', EpfChartjsDoughnut)
    .directive('epfChartjsLegend', EpfChartjsLegend)
    .factory('EpfChartjsFactory', EpfChartjsFactory);
})();
